import React from "react";
import PropTypes from "prop-types";
import { connect } from "alt-react";
import AccountStore from "stores/AccountStore";
import Translate from "react-translate-component";
import counterpart from "counterpart";
import { ChainStore, key } from "bitsharesjs/es";
import ReactTooltip from "react-tooltip";
import utils from "common/utils";
import SettingsActions from "actions/SettingsActions";
import WalletDb from "stores/WalletDb";
import AccountNameInput from "./../Forms/AccountNameInputStyleGuide";
import AccountSelect from "../Forms/AccountSelect";
import LoadingIndicator from "../LoadingIndicator";
import Icon from "../Icon/Icon";
import CopyButton from "../Utility/CopyButton";
import { Form, Input, Button, Tooltip } from "bitshares-ui-style-guide";

class AccountRegistrationForm extends React.Component {
  static propTypes = {
    continue: PropTypes.func.isRequired
  };

  constructor() {
    super();
    this.state = {
      validAccountName: false,
      accountName: "",
      registrarAccount: null,
      loading: false,
      generatedPassword: `P${key.get_random_key().toWif()}`,
      confirmPassword: ""
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onRegistrarAccountChange = this.onRegistrarAccountChange.bind(this);
    this.onAccountNameChange = this.onAccountNameChange.bind(this);
    this.onConfirmation = this.onConfirmation.bind(this);
    this.accountNameInput = null;
  }

  UNSAFE_componentWillMount() {
    SettingsActions.changeSetting({
      setting: "passwordLogin",
      value: true
    });
  }

  componentDidMount() {
    ReactTooltip.rebuild();
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !utils.are_equal_shallow(nextState, this.state);
  }

  onAccountNameChange(e) {
    const state = {};

    if (e.valid !== undefined) {
      state.validAccountName = e.valid;
    }

    if (e.value !== undefined) {
      state.accountName = e.value;
    }

    this.setState(state);
  }

  onRegistrarAccountChange(registrarAccount) {
    this.setState({
      registrarAccount
    });
  }

  onSubmit(e) {
    e.preventDefault();

    if (this.isValid()) {
      this.props.continue({
        accountName: this.state.accountName,
        password: this.state.generatedPassword
      });
    }
  }

  onConfirmation(e) {
    const value = e.currentTarget.value;
    this.setState({
      confirmPassword: value,
      passwordConfirmed: value === this.state.generatedPassword
    });
  }

  isValid() {
    const firstAccount = AccountStore.getMyAccounts().length === 0;
    let valid = this.state.validAccountName;

    if (!WalletDb.getWallet()) {
      valid = valid;
    }

    if (!firstAccount) {
      valid = valid && this.state.registrarAccount;
    }

    return valid;
  }

  renderAccountCreateForm() {
    const {
      registrarAccount
    } = this.state;
    const myAccounts = AccountStore.getMyAccounts();
    const firstAccount = myAccounts.length === 0;
    const valid = this.isValid();
    let isLTM = false;
    const registrar = registrarAccount ? ChainStore.getAccount(registrarAccount) : null;

    if (registrar) {
      if (registrar.get("lifetime_referrer") === registrar.get("id")) {
        isLTM = true;
      }
    }

    const getConfirmationPasswordHelp = () => {
      return this.state.confirmPassword && !this.state.passwordConfirmed ? counterpart.translate("wallet.confirm_error") : "";
    };

    const getConfirmationPasswordValidateStatus = () => {
      return this.state.confirmPassword && !this.state.passwordConfirmed ? "error" : "";
    };

    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Form, {
      onSubmit: this.onSubmit,
      layout: "vertical"
    }, /*#__PURE__*/React.createElement(AccountNameInput, {
      cheapNameOnly: firstAccount,
      onChange: this.onAccountNameChange,
      accountShouldNotExist: true,
      placeholder: counterpart.translate("account.name"),
      label: /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
        className: "vertical-middle"
      }, counterpart.translate("account.name")), "\xA0", /*#__PURE__*/React.createElement(Tooltip, {
        title: counterpart.translate("tooltip.registration.accountName")
      }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
        name: "question-in-circle",
        className: "icon-14px question-icon vertical-middle"
      })))),
      noLabel: true
    }), /*#__PURE__*/React.createElement(Form.Item, {
      label: counterpart.translate("wallet.generated")
    }, /*#__PURE__*/React.createElement(Input.TextArea, {
      disabled: true,
      style: {
        paddingRight: "50px"
      },
      rows: 2,
      id: "password",
      value: this.state.generatedPassword
    }), /*#__PURE__*/React.createElement(CopyButton, {
      text: this.state.generatedPassword,
      tip: "tooltip.copy_password",
      dataPlace: "top",
      className: "button registration-layout--copy-password-btn"
    })), /*#__PURE__*/React.createElement(Form.Item, {
      label: counterpart.translate("wallet.confirm_password"),
      help: getConfirmationPasswordHelp(),
      validateStatus: getConfirmationPasswordValidateStatus()
    }, /*#__PURE__*/React.createElement(Input, {
      placeholder: counterpart.translate("wallet.confirm_password"),
      type: "password",
      name: "password",
      id: "confirmPassword",
      value: this.state.confirmPassword,
      onChange: this.onConfirmation
    })), firstAccount ? null : /*#__PURE__*/React.createElement("div", {
      className: "full-width-content form-group no-overflow"
    }, /*#__PURE__*/React.createElement("label", {
      htmlFor: "account"
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "account.pay_from"
    })), /*#__PURE__*/React.createElement(AccountSelect, {
      id: "account",
      account_names: myAccounts,
      onChange: this.onRegistrarAccountChange
    }), registrarAccount && !isLTM ? /*#__PURE__*/React.createElement("div", {
      style: {
        textAlign: "left"
      },
      className: "facolor-error"
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.must_be_ltm"
    })) : null), this.state.loading ? /*#__PURE__*/React.createElement(LoadingIndicator, {
      type: "three-bounce"
    }) : /*#__PURE__*/React.createElement(Button, {
      htmlType: "submit",
      type: "primary",
      disabled: !valid || !this.state.passwordConfirmed || registrarAccount && !isLTM
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "registration.continue"
    }))));
  }

  renderAccountCreateText() {
    const myAccounts = AccountStore.getMyAccounts();
    const firstAccount = myAccounts.length === 0;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Translate, {
      component: "p",
      className: "model-description",
      content: "registration.accountDescription"
    }), firstAccount ? null : /*#__PURE__*/React.createElement(Translate, {
      component: "p",
      content: "wallet.not_first_account"
    }));
  }

  render() {
    return /*#__PURE__*/React.createElement("div", null, this.renderAccountCreateText(), this.renderAccountCreateForm());
  }

}

export default connect(AccountRegistrationForm, {
  listenTo() {
    return [AccountStore];
  },

  getProps() {
    return {};
  }

});